import type { PageResource } from '@/kinds/page/apply'
import type { ProjectResource } from '@/kinds/project/apply'
import { PageGlyph } from '@/kinds/page/components'
import { Icon } from '@/lib/icons'
import { Button, Sheet } from '@/components/ui'

/** Top level, a project, or another page (never itself or a descendant: the caller filters). */
export const MoveSheet = ({
  parent,
  projects,
  pages,
  onMove,
  onClose,
}: {
  parent: string | null
  projects: ProjectResource[]
  pages: PageResource[]
  onMove: (to: string | null) => Promise<void>
  onClose: () => void
}) => (
  <Sheet open onClose={onClose} title="Move page">
    <ul className="flex flex-col gap-1 max-h-[60vh] overflow-y-auto" data-testid="page-move-targets">
      <li>
        <Button
          className="w-full justify-start"
          variant={parent ? 'ghost' : 'chipOn'}
          onClick={() => void onMove(null)}
        >
          Top level
        </Button>
      </li>
      {projects.length > 0 && <li className="text-[13px] font-semibold text-faint px-2 pt-2">Projects</li>}
      {projects.map((p) => (
        <li key={p.id}>
          <Button
            className="w-full justify-start"
            variant={parent === p.id ? 'chipOn' : 'ghost'}
            onClick={() => void onMove(p.id)}
          >
            <Icon value={p.spec.icon} fallback="▣" /> {p.spec.title}
          </Button>
        </li>
      ))}
      {pages.length > 0 && <li className="text-[13px] font-semibold text-faint px-2 pt-2">Pages</li>}
      {pages.map((p) => (
        <li key={p.id}>
          <Button
            className="w-full justify-start"
            variant={parent === p.id ? 'chipOn' : 'ghost'}
            onClick={() => void onMove(p.id)}
          >
            <PageGlyph page={p} size={14} className="inline-block mr-1.5 align-[-2px]" />
            {p.name}
          </Button>
        </li>
      ))}
    </ul>
  </Sheet>
)
